import React from 'react'
import styled from "styled-components";

const BurgerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    margin: auto;
`;

const Burger = styled.div`
    width: 28px;
    height: 2px;
    position: relative;
    margin: 0 auto;
    background: ${props => props.isActive ? '#EB3D35' : '#141419'};
    transition: all 0ms .2s;
    &:before {
      content: "";
      width: 28px;
      height: 2px;
      position: absolute;
      left: 0;
      bottom: ${props => props.isActive ? '0' : '8px'};
      transform: ${props => props.isActive ? 'rotate(-45deg)' : 'rotate(0)'};
      background: ${props => props.isActive ? '#fff' : '#141419'};
      transition: ${props => props.isActive ? 'all .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s .2s cubic-bezier(0.23, 1, 0.32, 1)' : 'all .2s .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s cubic-bezier(0.23, 1, 0.32, 1)'};
    }
    &:after {
      content: "";
      width: 28px;
      height: 2px;
      position: absolute;
      left: 0;
      top: ${props => props.isActive? '0' : '8px'};
      transform: ${props => props.isActive ? 'rotate(45deg)' : 'rotate(0)'};
      background: ${props => props.isActive ? '#fff' : '#141419'};
      transition: ${props => props.isActive ? 'all .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s .2s cubic-bezier(0.23, 1, 0.32, 1)' : 'all .2s .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s cubic-bezier(0.23, 1, 0.32, 1)'};
    }
`;

const Hamburger = ({ isActive}) => (
  <BurgerWrapper>
    <Burger isActive={isActive} />
  </BurgerWrapper>
);

export default Hamburger


// WEBPACK FOOTER //
// ./src/components/MobNav/hamburger.js